import { Injectable } from '@angular/core';
import { StorageEntityName } from '../model/storage.model';
import { PendingPhotoCapture } from '../model/session-recovery.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class PendingPhotoService {
  constructor(private readonly storage: StorageService) { }

  async savePendingCapture(capture: PendingPhotoCapture): Promise<void> {
    await this.storage.set(StorageEntityName.pendingPhotoCapture, capture);
  }

  async getPendingCapture(): Promise<PendingPhotoCapture | null> {
    return await this.storage.get<PendingPhotoCapture>(
      StorageEntityName.pendingPhotoCapture
    );
  }

  async clearPendingCapture(): Promise<void> {
    await this.storage.remove(StorageEntityName.pendingPhotoCapture);
  }
}
